import * as React from "react"
import Container from "../container/container"

import * as styles from "./help.module.scss"
import Markdown from "react-markdown"

const AboutHelp = props => {
  return (
    <div className={styles.help}>
      <Container>
        <h2>{props.data.ImproveHeading}</h2>
        <Markdown className={styles.help__intro}>
          {props.data.ImproveSummary}
        </Markdown>
        <div
          className={`${styles.help__columns} d-flex align-items-start justify-content-evenly`}
        >
          <div className={styles.help__columns__column}>
            <Markdown>{props.data.ImproveBodyOne}</Markdown>
          </div>
          <div className={styles.help__columns__column}>
            <Markdown>{props.data.ImproveBodyTwo}</Markdown>
          </div>
        </div>
      </Container>
    </div>
  )
}

export default AboutHelp
